import { Icons, Logos } from '@assets';
import { IUser } from '@types';
import React from 'react';
import * as S from '../../style/DesktopNavbar.styled';
import DropdownMenu from './DropdownMenu';

interface NavbarHeaderProps {
    user: IUser | null;
}

const NavbarHeader: React.FC<NavbarHeaderProps> = ({ user }) => {
    return (
        <S.NavHeaderLineWrap>
            <S.NavLogo>
                <img src={Logos.LogoWhite} alt="Proga.pro logo" />
            </S.NavLogo>
            <S.AccountInfoWrap>
                <S.StyledInfo>
                    <img src={Icons.Wallet} alt="" />
                    {`Баланс ${user?.state ?? 0} ₽`}
                </S.StyledInfo>
                <DropdownMenu />
                <S.StyledInfo>{`${user?.firstname ?? ''} ${
                    user?.lastname ?? ''
                }`}</S.StyledInfo>
            </S.AccountInfoWrap>
        </S.NavHeaderLineWrap>
    );
};

export default NavbarHeader;
